import React from 'react';
import { Card, CardContent, Box, Typography, TextField, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Paper, Skeleton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { formatNum, formatPercent, formatCurrency } from './dashboardUtils';

const COLUMN_COUNT = 11;

const DashboardTeamsTable = ({ teamsMetrics, loading, search, onSearchChange, page, rowsPerPage, onPageChange, onRowsPerPageChange }) => {
  const searchLower = (search || '').toLowerCase().trim();
  const filtered = !searchLower ? teamsMetrics : teamsMetrics.filter((t) => (t.name ?? t.team_name ?? '').toLowerCase().includes(searchLower));
  const from = page * rowsPerPage;
  const paginated = filtered.slice(from, from + rowsPerPage);

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>Per Team</Typography>
          <TextField size="small" placeholder="Search team..." value={search} onChange={(e) => onSearchChange(e.target.value)} sx={{ minWidth: 220 }} InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon color="action" /></InputAdornment> }} />
        </Box>
        <TableContainer component={Paper} variant="outlined" sx={{ overflowX: 'auto' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Team</TableCell>
                <TableCell align="right">Total Leads</TableCell>
                <TableCell align="right">Orders</TableCell>
                <TableCell align="right">Sales</TableCell>
                <TableCell align="right">Revenue</TableCell>
                <TableCell align="right">Declined</TableCell>
                <TableCell align="right">In Process</TableCell>
                <TableCell align="right">Not Interested</TableCell>
                <TableCell align="right">Follow Up</TableCell>
                <TableCell align="right">Pending</TableCell>
                <TableCell align="right">Conversion</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? [...Array(3)].map((_, i) => <TableRow key={i}><TableCell colSpan={COLUMN_COUNT}><Skeleton height={36} /></TableCell></TableRow>) : filtered.length === 0 ? (
                <TableRow><TableCell colSpan={COLUMN_COUNT} sx={{ textAlign: 'center', py: 3 }}>{teamsMetrics.length === 0 ? 'No data found.' : 'No teams match your search.'}</TableCell></TableRow>
              ) : paginated.map((row) => (
                <TableRow key={row.id ?? row.team_id ?? row.name}>
                  <TableCell>{row.name ?? row.team_name ?? '—'}</TableCell>
                  <TableCell align="right">{formatNum(row.total_leads ?? row.leads_count)}</TableCell>
                  <TableCell align="right">{formatNum(row.orders_total)}</TableCell>
                  <TableCell align="right">{formatNum(row.sales_generated ?? row.sales)}</TableCell>
                  <TableCell align="right">{formatCurrency(row.revenue ?? 0)}</TableCell>
                  <TableCell align="right">{formatNum(row.leads_declined ?? row.declined)}</TableCell>
                  <TableCell align="right">{formatNum(row.leads_in_process ?? row.in_process)}</TableCell>
                  <TableCell align="right">{formatNum(row.not_interested)}</TableCell>
                  <TableCell align="right">{formatNum(row.follow_up)}</TableCell>
                  <TableCell align="right">{formatNum(row.pending)}</TableCell>
                  <TableCell align="right">{formatPercent(row.conversion_rate ?? row.team_conversion_rate)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {!loading && filtered.length > 0 && (
          <TablePagination component="div" count={filtered.length} page={page} onPageChange={(_, newPage) => onPageChange(newPage)} rowsPerPage={rowsPerPage} onRowsPerPageChange={(e) => onRowsPerPageChange(Number(e.target.value))} rowsPerPageOptions={[5, 10, 25, 50]} labelRowsPerPage="Rows per page" />
        )}
      </CardContent>
    </Card>
  );
};

export default DashboardTeamsTable;
